import Http from '../../HttpService/HttpService'

export default function agent({next, store}) {
    /*if (!store.getters.isAuthenticated) {
        window.location = Http.addressImage()
    }*/

    return next()
}